import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Modal } from 'containers/misc'
import { Data, Table } from 'components/layout/Table'
import { Button, FormData, Module, Status } from 'components/misc'
import { AssessorReport, AssessorResendAssessment, AssessorSendWelcomeEmail } from 'containers/sections/assessors'
import { AssessorChange } from 'containers/forms/assessors'
import { activities as activitiesLayout } from 'constants/layout'
import {
  ACTIVITY_CATEGORIES,
  PROGRESS_STATES
} from 'constants/enums'
import { apiActivities, apiAssessors, apiResidentialProjects } from 'helpers/decorators/api'
import moment from 'moment'
import styles from './assessor-report-block.styl'
import { FormattedDate } from 'components/intl'
import { HashLink as Link } from 'react-router-hash-link'
import config from 'config'

@apiAssessors()
@apiActivities()
@apiResidentialProjects()
class AssessorReportBlock extends Component {
  static propTypes = {
    modal: PropTypes.func,
    changeAssessor: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    actionId: PropTypes.number,
    state: PropTypes.object,
    data: PropTypes.object,
    award: PropTypes.object,
    assessmentActionId: PropTypes.number,
    isActivity: PropTypes.bool,
    isParticipantEvent: PropTypes.bool,
    isResidentialProject: PropTypes.bool,
    isAssessmentPositive: PropTypes.bool,
    returnedToParticipant: PropTypes.bool,
    isAssessorDetailMandatory: PropTypes.bool,
    isAssessorWelcomeEmailEnabled: PropTypes.bool,
    isAssessorReportAdditionalInfoEnabled: PropTypes.bool,
    isAssessorManagementEnabled: PropTypes.bool,
    assessors: PropTypes.object,
    assessorsList: PropTypes.array,
    values: PropTypes.object,
    actions: PropTypes.object,
    getActivityReport: PropTypes.func,
    getRPReport: PropTypes.func
  }

  static defaultProps = {
    state: {},
    data: {},
    isAssessorDetailMandatory: false,
  }

  key = uuid.v1()

  getRequestedDaysCount = (activityState, assessorRequestDate, dateField) => {
    if (activityState === PROGRESS_STATES.activityAssessment.id) {
      return (<div className={styles.requestedOn}>
        <div className={styles.label}>
          <FormattedMessage
            id="label.requested_on"
            defaultMessage="Requested on:"
          />
        </div>
        <p>{assessorRequestDate &&
          <FormattedDate value={assessorRequestDate} />} {assessorRequestDate ? '(' + dateField + ')' : '---'}</p>
      </div>)
    }
  }

  getAssessorName = data => {
    const existingAssessor = get(data, 'assessor.id')

    const name = data.assessorName || '---'

    if (existingAssessor) {
      return (<Link
        to={{
          pathname: `${config.publicPath}/organizations/${get(data, 'assessor.organization.id')}/assessors/${get(data, 'assessor.person.id')}/detail`
        }}
      > {name}</Link>)
    } else {
      return name
    }
  }

  getLinkToActivity = () => {
    const location = get(this.props, 'location.pathname')

    const url = location.startsWith('/bo') ? location.trim().substring(3, location.length) : location

    return (<Link to={`${config.publicPath}${url}#assessorAnchor`}>
      <FormattedMessage
        id="label.add_below"
        defaultMessage="Add below"
      />
    </Link>)
  }

  getActivityReport = activityId => {
    this.props.getActivityReport(activityId)
  }

  getRPReport = rpId => {
    this.props.getRPReport(rpId)
  }


  render () {
    const {
      id,
      data,
      award,
      actionId,
      isActivity,
      isParticipantEvent,
      isResidentialProject,
      isAssessmentPositive,
      returnedToParticipant,
      assessmentActionId,
      state,
      isAssessorDetailMandatory,
      isAssessorWelcomeEmailEnabled,
      actions,
      isAssessorReportAdditionalInfoEnabled,
      isAssessorManagementEnabled,
      values,
      assessorsList
    } = this.props

    const filteredActions = actions && actions.filter(a => get(a, 'id') === actionId)

    const assessmentAction = filteredActions && filteredActions[0]

    const assessorRequestDate = get(data, 'assessmentRequestDate')

    const dateMoment = moment(assessorRequestDate)

    const dateField = dateMoment.isValid()
      ? dateMoment.fromNow()
      : assessorRequestDate

    const activityState = get(data, 'activityState.value')

    const rpState = get(data, 'state.value')

    const isSubCategorySelected = get(values, 'activityCategory.id')

    const isOthersSubCategory = isSubCategorySelected === ACTIVITY_CATEGORIES.other.id


    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': () => this.props.modal('modal-change-assessor'),
        'iconAction': null,
        'isActionLoading': null,
        'intlKeyAction': 'button.change',
        'action': state.value === PROGRESS_STATES.activityInProgress.id ||
        state.value === PROGRESS_STATES.activityAssessment.id
          ? 'Change'
          : null
      },
      {
        'order': 2,
        'secondary': true,
        'onClick': () => this.props.modal(`modal-resend-assessment-request-${this.key}`),
        'iconAction': null,
        'isActionLoading': null,
        'intlKeyAction': 'button.resend_assessment_request',
        'action': !isAssessmentPositive &&
        !returnedToParticipant &&
        data.assessorEmail &&
        state.value === PROGRESS_STATES.activityAssessment.id
          ? 'Resend assessment request'
          : null
      },
      {
        'order': 3,
        'secondary': true,
        'onClick': () => this.props.modal(`modal-send-assessor-welcome-email-${this.key}`),
        'iconAction': null,
        'isActionLoading': null,
        'intlKeyAction': 'label.send_welcome_email',
        'action': isAssessorWelcomeEmailEnabled && !isAssessorManagementEnabled && data.assessorEmail &&
        state.value === PROGRESS_STATES.activityInProgress.id
          ? <FormattedMessage id='label.send_welcome_email' defaultMessage='Send Welcome Email' />
          : null
      },
      {
        'order': 4,
        'secondary': true,
        'isDownload': true,
        'url': isActivity ? `/activities/${id}/summary-report-generation` : `/residential-projects/${id}/summary-report-generation`,
        'iconAction': null,
        'isActionLoading': null,
        'intlKeyAction': 'button.download_section_summary',
        'action': <FormattedMessage id='button.download_section_summary' defaultMessage='Download Section Summary' />
      }
    ]

    return (
      <div className="base-margin-small--bottom">
        <Module
          title="Assessor detail"
          intlKey="moduleTitle.assessor_detail"
          buttonDefinition={buttonDefinition}
          primary
          grid
        >

          <div className="row">
            <div className="col-xs-1">
              <FormData label="Title" intlKey="label.title">
                {data.assessorTitle || '---'}
              </FormData>
            </div>
            <div className="col-xs-2">
              <FormData label="Name" intlKey="label.name">
                {this.getAssessorName(data)}
              </FormData>
            </div>
            <div className="col-xs-3">
              <FormData label="Email" intlKey="label.email">
                {data.assessorEmail || '---'}
              </FormData>
            </div>
            <div className="col-xs-2">
              <FormData label="Phone" intlKey="label.phone">
                {data.assessorPhone || '---'}
              </FormData>
            </div>


            {isAssessorManagementEnabled && <div className="col-xs-2">
              <FormData label="Relevant Experience" intlKey="label.relevant_experience">
                {data.assessorRelevantExperience || '---'}
              </FormData>
            </div>}


            {isAssessorManagementEnabled && <div className="col-xs-1">
              <FormData label="State" intlKey="label.state">
                {get(data, 'assessorRegistrationState') || '---'}
              </FormData>
            </div>}

            {isAssessorManagementEnabled && (state.value === PROGRESS_STATES.activitySetup.id ||
              state.value === PROGRESS_STATES.activityApproval.id) && <div className="col-xs-1">
                <div className={styles.addBBelow}>
                {this.getLinkToActivity()}
              </div>
            </div>}

            {this.getRequestedDaysCount(activityState, assessorRequestDate, dateField)}
            {this.getRequestedDaysCount(rpState, assessorRequestDate, dateField)}

          </div>
        </Module>
        {
          assessmentActionId !== null && (
            <Table ths={activitiesLayout.assessorTable}>
              <Data>
                <tr>
                  <td style={{ width: 200 }}>
                    {isAssessmentPositive &&
                      !returnedToParticipant && (
                        <Status state={isAssessmentPositive} check />
                      )}
                    {!isAssessmentPositive &&
                      returnedToParticipant &&
                      assessmentActionId !== null && (
                        <FormattedMessage
                          id="assessor_report.returned_to_participant"
                          defaultMessage="Returned to participant"
                        />
                      )}
                    {!isAssessmentPositive && !returnedToParticipant && '---'}
                  </td>
                  <td>
                    {actionId && isAssessmentPositive ? (
                      <Button
                        link
                        type="button"
                        intlKey="button.view"
                        onClick={() =>
                          this.props.modal(
                            `modal-display-assessor-report-${this.key}`,
                          )}
                      >
                        View
                      </Button>
                    ) : (
                      <FormattedMessage
                        id="label.rejected_with_note"
                        defaultMessage='Rejected with a note: "{note}"'
                        values={{ note: get(assessmentAction, 'note') }}
                      />

                    )}
                  </td>
                </tr>
              </Data>
            </Table>
          )
        }
        <Modal id={`modal-display-assessor-report-${this.key}`}>
          <AssessorReport
            id={id}
            actionId={actionId}
            isActivity={isActivity}
            isParticipantEvent={isParticipantEvent}
            isResidentialProject={isResidentialProject}
            assessed
            isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
          />
        </Modal>
        <Modal id={`modal-resend-assessment-request-${this.key}`} customActions>
          <AssessorResendAssessment
            id={id}
            actionId={actionId}
            isActivity={isActivity}
            isParticipantEvent={isParticipantEvent}
            isResidentialProject={isResidentialProject}
            assessed
          />
        </Modal>
        <Modal id={`modal-send-assessor-welcome-email-${this.key}`} customActions>
          <AssessorSendWelcomeEmail
            id={id}
            actionId={actionId}
            isActivity={isActivity}
            isParticipantEvent={isParticipantEvent}
            isResidentialProject={isResidentialProject}
            assessed
          />
        </Modal>
        <Modal id="modal-change-assessor" customActions enableOverflow>
          <AssessorChange
            data={values}
            onSubmit={this.props.changeAssessor}
            onRequestClose={() => this.props.modal(null)}
            isAssessorDetailMandatory={isAssessorDetailMandatory}
            isResidentialProject={isResidentialProject}
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            isOthersSubCategory={isOthersSubCategory}
            isSubCategorySelected={isSubCategorySelected}
            assessors={assessorsList}
            orgId={get(award, 'organization.id')}
          />
        </Modal>
      </div>
    )
  }
}

export default AssessorReportBlock
